<template>
  <b-container fluid>
    <b-row>
      <b-col md="3" v-if="piportals && piportals.length > 1">
        <b-form-group
          id="fieldset-1"
          label="Выберите сервер"
        >
          <b-form-select v-model="portalId"
                         id="select-server"
                         :options="portals"
                         value-field="alias"
                         text-field="name"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          id="fieldset-2"
          label="Дата создания"
        >
          <ctk-date-time-picker
            v-model="datePickerValue"
            id="DateTimePickerPackages"
            label="Дата с ... дата по ..."
            color="#40b539"
            locale="ru"
            range
            :custom-shortcuts="customShortcuts"
            format="YYYY-MM-DD HH:mm"
            formatted="ll"
          >
          </ctk-date-time-picker>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          id="fieldset-3"
          label="Категория"
        >
        <b-form-select id="filter-by-category" v-model="selected" :options="options"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          id="fieldset-4"
          label="Поиск"
        >
          <b-form-input id="search-input" v-model="searchText" placeholder="Введите текст"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col :md="piportals && piportals.length > 1 ? '2' : '2'" class="d-flex align-items-center">
        <b-button variant="success" :disabled="!portalId || !datePickerValue" @click="loadPackagesBySearchButton(1)" class="mt-3">Поиск
        </b-button>
      </b-col>
      <!-- b-col md="3">
        <b-form-group>
          <b-form-input id="search-input" class="mt-7" v-model="filter" placeholder="Поиск по таблице"/>
          <div class="container_search_close"
               @click="filter = ''">
            <span class="search-close">&#215;</span>
          </div>
        </b-form-group>
      </b-col -->
    </b-row>
    <b-table
      hover
      show-empty
      responsive
      ref="packages"
      id="data_table"
      :fields="fields"
      :items="items"
      :busy="visible"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      @row-hovered="rowHowered"
      @row-unhovered="rowUnhowered"
      class="mt-3 blue technical-support"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
      :sort-compare="mySortCompare"
    >
      //package
      <template v-slot:cell(package)="data">
        <b><p class="mb-0">{{ data.item.pid }}<span
          v-if="data.item.pid !== data.item.chainid">/{{ data.item.chainid }}</span></p></b>
        <b-badge :variant="convertToStatusColor(data.item.status)">{{ convertStatus(data.item.status) }}</b-badge>
      </template>
      //waybill
      <template v-slot:cell(waybill)="data">
        <div v-if="data.item.info[101] && ((data.item.info[101].length - 1) > 9)" class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[101]" :key="item">
            <span v-if="index < 9">{{ item }}, </span>
            <span v-else-if="index === 9">{{ item }}...</span>
          </div>
        </div>
        <div v-else class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[101]" :key="item">
            <span v-if="(index < (data.item.info[101].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </div>
        </div>
      </template>
      //vehicle
      <template v-slot:cell(vehicle)="data">
        <div v-if="data.item.info[104] && ((data.item.info[104].length - 1) > 9)" class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[104]" :key="item">
            <span v-if="index < 9">{{ item }}, </span>
            <span v-else-if="index === 9">{{ item }}...</span>
          </div>
        </div>
        <div v-else class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[104]" :key="item">
            <span v-if="(index < (data.item.info[104].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </div>
        </div>
      </template>
      //place_of_delivery
      <template v-slot:cell(place_of_delivery)="data">
        <p v-if="data.item.info[108]" class="mb-0">{{ data.item.info[108][0] }}</p>
      </template>
      //organization
      <template v-slot:cell(organization)="data">
        <div v-if="data.item.info[103] && ((data.item.info[103].length - 1) > 3)" class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[103]" :key="item">
            <span v-if="index < 3">{{ item }}, </span>
            <span v-else-if="index === 3">{{ item }}...</span>
          </div>
        </div>
        <div v-else class="mb-0 pl-4">
          <div v-for="(item, index) in data.item.info[103]" :key="item">
            <span v-if="(index < (data.item.info[103].length - 1))">{{ item }}, </span>
            <span v-else>{{ item }}</span>
          </div>
        </div>
      </template>
      // package
      <template v-slot:cell(modify_datetime)="data">
        <div class="user-creator-wrapper">
          <i class="fas fa-user" v-b-tooltip.hover title="Создатель"></i>
          <span class="user-creator">{{ data.item.sender }}</span>
        </div>
        <div class="created-date-wrapper">
          <i class="fas fa-clock" v-b-tooltip.hover
             :title="getDateTooltip(data.item.creationdate, data.item.getlastmodified)"></i>
          <span class="created-date">{{ getDate(data.item.creationdate, data.item.getlastmodified) }}</span>
        </div>
        <div class="destination-wrapper">
          <i class="fas fa-arrow-alt-circle-right" v-b-tooltip.hover title="Получатель"></i>
          <span class="destination"><b-badge :variant="convertToDirectionColor(data.item.receiver)">{{ convertToDirection(data.item.receiver) }}</b-badge></span>
        </div>
      </template>
      // actions
      <template v-slot:cell(actions)="row">
        <actions
          ref="actions"
          :visible="row.item.actions.visible"
          :target="row.item.index"
          :status="row.item.status"
          :manifest="row.item.manifest"
          @open_documents="openDocuments(row)"
          @loadCommitmentStatement="getCommitmentStatement($event, row)"
          @loadEmptyContRegTable="getEmptyContRegTable($event, row)"
          @download_manifest="getManifest($event, row)">
        </actions>
      </template>
      // documents
      <template slot="row-details" slot-scope="row">
        <div v-if="row.item.documents" class="attachments-wrapper">
          <div class="mb-4 no-documents" v-if="row.item.documents.length === 0">Нет документов</div>
          <div v-else v-for="document in row.item.documents"
               :style="{ width: (row.item.documents.length > 1) ? '' : '100%' }"
               @click="openDocument($event, document, row)"
               :key="document.id">
            <div v-if="document.html.length > 0" class="attachment" :style="{ width: attachmentWidth + 'px', position: 'relative' }">
              <div class="attachment-inner-container">
                <div class="file-icon-wrapper">
                  <i v-if="document.documentName.indexOf('с решением') !== -1" class="fas fa-file-signature text-success"></i>
                  <i v-else class="fas fa-file-alt"></i>
                </div>
                <div class="attachment-name-wrapper">
                  <div class="mr-4" v-html="document.documentName"></div>
                </div>
              </div>
            </div>
            <div v-if="checkHtml(row.item.documents.slice()) === 0" class="mb-4 no-documents">Нет документов</div>
          </div>
        </div>
        <div v-else class="text-center text-secondary my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Загрузка...</strong>
        </div>
      </template>

      <div slot="table-busy" class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загружаем данные...</strong>
      </div>
    </b-table>
    <b-row>
      <b-col>
        <!--b-form inline>
          <label class="mr-3">Показать</label>
          <b-form-select :options="pageOptions"
                         v-model="perPage"
                         size="sm"/>
        </b-form-->
      </b-col>
      <b-col>
        <b-pagination align="right"
                      prev-text="&lt;"
                      first-text="&lt;&lt;"
                      next-text="&gt;"
                      last-text="&gt;&gt;"
                      size="sm"
                      :total-rows="pages*10*2"
                      :per-page="perPage"
                      @input="loadPackagesByPagination"
                      v-model="currentPage">
        </b-pagination>
      </b-col>
    </b-row>
    <b-modal id="openDocument" class="package-modal text-center" @shown="addHtmlToIframe" @hidden="resetProps"
             size="xl">
      <template slot="modal-title">
        <div v-html="documentName"></div>
      </template>
      <iframe id="showDocument" width="100%" height="100%"></iframe>
      <template slot="modal-footer">
        <b-button @click="printDocument">Распечатать</b-button>
        <b-button v-if="(!documentFileName && documentName && (documentName.toLowerCase().indexOf('с решением') !== -1))" @click="downloadCommisionShipmentDecision">
          <div v-if="!busyCommisionShipment">Скачать в PDF</div>
          <div v-else class="d-flex align-items-center justify-content-center">
            <b-spinner type="grow" small label="Загружается..." class="mr-3"></b-spinner><span>Идёт загрузка...</span>
          </div>
        </b-button>
        <b-button v-if="(documentFileName && (documentFileName.toLowerCase() === 'armti-commissionshipment.cfg.xml'))" @click="downloadDocumentPdf">Скачать в PDF</b-button>
        <b-button v-if="(documentFileName && (documentFileName.toLowerCase() === 'billoflading.html.cfg.xml'))" @click="downloadDocumentPdf">Скачать в PDF</b-button>
        <b-button v-if="(documentFileName && (documentFileName.toLowerCase() === 'commissionshipmentdecision.html.cfg.xml'))" @click="downloadDocumentPdf">Скачать в PDF</b-button>
        <b-button v-if="(documentXml && (documentXml.length > 0) && (documentName.indexOf('с решением') === -1))"
                  @click="downloadDocumentXml">Скачать в XML
        </b-button>
        <b-button v-if="(documentName && (documentName.indexOf('с решением') !== -1))" @click="downloadDocumentXml">
          Скачать XML решения
        </b-button>
      </template>
    </b-modal>
    <b-modal ref="editCommitmentStatement" size="xl" hide-footer title="Редактирование шаблона заявления">
      <div id="commitmentStatementContainer"
           style="border: 1px solid black; width: 794px; padding: 55px 37px 55px 55px; margin: auto; position: relative">
        <div>
          <table style="width: 100%">
            <tbody>
            <tr>
              <td style="width: 50%; vertical-align: top;">
                <div class="float-left">
                  <ctk-date-time-picker
                    id="reportDatePicker1"
                    v-model="reportDatePickerValue1"
                    style="width: 170px"
                    label="Выберите дату"
                    color="#40b539"
                    locale="ru"
                    format="YYYY-MM-DD"
                    buttonNowTranslation="Сегодня"
                    formatted="LL"
                    onlyDate
                  >
                  </ctk-date-time-picker>
                </div>
              </td>
              <td style="width: 50%; text-align: right; vertical-align: top; font-size: 13px;">
                <span>Балтийская таможня</span><br><span>т/п Бронка</span></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="font-size: 13px; text-align: center; margin-bottom: 15px;"><b>Заявление-обязательство о временном
          ввозе товаров</b></div>
        <div class="d-flex justify-content-center align-items-center" style="font-size: 13px; margin-bottom: 15px;">
          <div>53/10216160/</div>
          <div>
            <ctk-date-time-picker
              id="reportDatePicker2"
              v-model="reportDatePickerValue1"
              style="width: 170px"
              label="Выберите дату"
              color="#40b539"
              locale="ru"
              format="YYYY-MM-DD"
              buttonNowTranslation="Сегодня"
              formatted="DDMMYY"
              onlyDate
            >
            </ctk-date-time-picker>
          </div>
          <div>/ЗО0____________</div>
        </div>
        <div style="width: 100%; font-size: 13px;">
          Просим Вас разрешить временный ввоз порожних контейнеров, указанных в табл. №1 на территорию Таможенного
          союза, в соответствии с Приложением В.3. к Конвенции о временном ввозе от 26.06.1990 года, с полным
          освобождением от уплаты таможенных платежей.
        </div>
        <div style="margin-bottom: 15px; font-size: 13px; font-style: italic; text-align: right;">Таблица №1</div>
        <div style="margin-bottom: 15px;">
          <table style="font-size: 13px; width: 100%; border: 1px solid black;">
            <thead>
            <th style="padding: 5px; border-right: 1px solid black; text-align: center;">№<br> п/п</th>
            <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Наименование</th>
            <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Кол-во,<br> шт.</th>
            <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Вес, кг</th>
            <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Стоимость,<br> евро</th>
            <th style="padding: 5px; border-right: 1px solid black; text-align: center;">Коносамент</th>
            <th style="padding: 5px; text-align: center;">Судно</th>
            </thead>
          </table>
        </div>
        <div style="font-size: 13px;">Настоящим АО «Контейнершипс Санкт-Петербург» обязуется перед т/п Бронка Балтийской
          таможни возвратить
        </div>
        <div style="font-size: 13px;" class="d-flex justify-content-start align-items-center">
          <div style="font-size: 13px; margin-right: 8px;">товары, указанные в табл.№1 в неизменном состоянии в срок
            до
          </div>
          <div style="font-size: 13px; margin-right: 8px;">
            <ctk-date-time-picker
              id="reportDatePicker3"
              v-model="reportDatePickerValue2"
              style="width: 170px;"
              label="Выберите дату"
              color="#40b539"
              locale="ru"
              format="YYYY-MM-DD"
              buttonNowTranslation="Сегодня"
              formatted="DD/MM/YYYY"
              onlyDate
            >
            </ctk-date-time-picker>
          </div>
          <div style="font-size: 13px;">г.</div>
        </div>
        <div style="font-size: 13px;">
          <p>Контейнеры принадлежат Containerships - CMA-CGM GmbH.</p>
          <p>Об ответственности, установленной КоАП РФ за несоблюдение таможенной процедуры временного ввоза АО
            «Контейнершипс Санкт-Петербург» предупрежден.</p>
          <div>
            <b-form-textarea
              style="font-size: 13px;"
              id="report-signature"
              v-model="reportSignatureText"
              placeholder="Введите текст"
              rows="3"
            ></b-form-textarea>
          </div>
          <div>
            Отметка должностного лица таможенного органа_________________________________________<br>
            Товар соответствует заявленным сведениям
          </div>
        </div>
      </div>
      <div style="text-align: center; margin-top: 15px;">
        <b-button @click="downloadCommitmentStatement" variant="success">
          <div v-if="!busyCommitmentStatement">Сформировать и скачать ЗО</div>
          <div v-else class="d-flex align-items-center justify-content-center">
            <b-spinner type="grow" label="Загружается..." class="mr-3"></b-spinner><span>Идёт загрузка...</span>
          </div>
        </b-button>
      </div>
    </b-modal>
    <div id="myTestDiv"
         style="position: absolute; top: -794px; left: 12000px; border: 1px solid black; width: 1123px; height: 794px; padding: 20px 20px;"></div>
    <div id="myTest"
         style="position: absolute; top: -1123px; left: 12000px; border: 1px solid black; width: 794px; height: 1123px; padding: 20px 20px;"></div>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { converterMixin } from './converterMixin'
import { getManifestMixin } from './getManifestMixin'
import { getCommitmentStatementMixin } from './getCommitmentStatementMixin'
import { getCommisionShipmentDecisionMixin } from './getCommisionShipmentDecisionMixin'
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import html2pdf from '../../node_modules/html2pdf.js/dist/html2pdf.js'
import Actions from './Actions'
import moment from 'moment'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'packages',
  mixins: [converterMixin, getManifestMixin, getCommitmentStatementMixin, getCommisionShipmentDecisionMixin],
  components: {
    CtkDateTimePicker,
    Actions
  },
  data () {
    return {
      portalId: null,
      fields: [
        { key: 'package', label: 'Пакет' },
        { key: 'waybill', label: '№ накладной' },
        { key: 'organization', label: 'Организации' },
        { key: 'vehicle', label: 'Транспорт' },
        { key: 'place_of_delivery', label: 'Место доставки' },
        { key: 'modify_datetime', label: 'Параметры' },
        { key: 'actions', label: 'Действия', tdClass: 'actions-fixed-width' }
      ],
      items: [],
      datePickerValue: { start: '', end: '' },
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      filter: null,
      filterOn: ['id', 'vehicle', 'waybill', 'converted_status'],
      searchPackage: null,
      disableButton: true,
      modified: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 0,
      pageOptions: [10, 20, 50],
      sortBy: 'modify_datetime',
      sortDesc: false,
      sortDirection: 'asc',
      attachmentWidth: null,
      documentName: null,
      documentHtml: null,
      documentHtmlForPdf: null,
      documentXml: null,
      documentId: null,
      documentAdditionalTable: null,
      documentGeneralInformation: null,
      documentFileName: null,
      mergedDocumentXml: null,
      rowInProgress: null,
      reportDatePickerValue1: '',
      reportDatePickerValue2: '',
      reportSignatureText: 'С уважением, Зайцев А.И. Руководитель отдела экспедирования и декларирования грузов АО «Контейнершипс Санкт-Петербург»',
      busyCommitmentStatement: false,
      busyCommisionShipment: false,
      commitmentStatementRow: null,
      selected: '',
      options: [
        { value: '', text: 'Все' },
        { value: 'transport', text: 'Транспорт' },
        { value: 'organization', text: 'Организации' },
        { value: 'waybill', text: 'Номер накладной' },
        { value: 'delivery', text: 'Место доставки' }
      ],
      searchText: ''
    }
  },
  watch: {
    searchPackage () {
      this.disableButton = !(this.searchPackage !== null && this.portalId !== null)
    }
  },
  mounted () {
    // this.showModal()
    if (this.piportals && this.piportals.length === 1) {
      this.portalId = this.piportals[0].alias.replace(' ', '')
      this.getStatuses({ portalId: this.portalId }).then(
        () => {
          this.loadPackages(1)
        },
        error => {
          console.log(error)
        }
      )
    } else {
      this.getPortalsList().then(
        () => {
          this.portalId = this.portals[0].alias
          // this.loadDefinitePackage()
        },
        error => {
          console.log(error)
        }
      )
    }
    this.datePickerValue.start = this.moment(new Date()).add(-2, 'days').format('YYYY-MM-DD 00:00')
    this.datePickerValue.end = this.moment(new Date()).format('YYYY-MM-DD 23:59')
    this.attachmentWidth = Math.round((window.innerWidth - 16 * 9 - 30) / 5)
    if (this.attachmentWidth < 300) {
      this.attachmentWidth = 300
    } else if (this.attachmentWidth > 400) {
      this.attachmentWidth = 400
    }
    this.reportDatePickerValue1 = this.moment(new Date()).format('YYYY-MM-DD')
    this.reportDatePickerValue2 = this.moment(new Date()).add(6, 'months').format('YYYY-MM-DD')
  },
  computed: {
    ...mapState(
      {
        portals: state => state.packages.portals,
        packages: state => state.packages.packages,
        definitePackage: state => state.packages.definitePackage,
        visible: state => state.packages.visible,
        documents: state => state.packages.documents,
        loading: state => state.packages.loading,
        piportals: state => state.authorization.userInfo.piportals,
        statuses: state => state.packages.statuses,
        userInfo: state => state.authorization.userInfo,
        pages: state => state.packages.pages,
        pids: state => state.packages.pids
      }
    )
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    rowHowered (item, index, event) {
      item.actions.visible = true
    },
    rowUnhowered (item, index, event) {
      item.actions.visible = false
    },
    getDateTooltip (createDateTime, modifyDateTime) {
      const create = this.moment(createDateTime).format('DD.MM.YYYY')
      const modify = this.moment(modifyDateTime).format('DD.MM.YYYY')
      if (create === modify) {
        return 'Дата создания'
      } else {
        return 'Дата создания/Дата модификации'
      }
    },
    getDate (createDateTime, modifyDateTime) {
      const create = this.moment(createDateTime).format('DD.MM.YYYY')
      const modify = this.moment(modifyDateTime).format('DD.MM.YYYY')
      if (create === modify) {
        return create
      } else {
        return create + '/' + modify
      }
    },
    mySortCompare (aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
      const a = aRow[key]
      const b = bRow[key]
      if (key === 'modify_datetime') {
        return new Date(b) - new Date(a)
      }
    },
    checkHtml (documents) {
      const hasHtml = documents.filter(document => document.html.length > 0)
      return hasHtml.length
    },
    convertStatus (id) {
      const status = this.statuses.filter((s) => {
        return s.id === id
      })
      return status[0].name
    },
    getEmptyContRegTable (event, row) {
      let host = ''
      switch (this.userInfo.piportals[0].name) {
        case 'App Fill-Bill':
          host = 'app.fill-bill.ru'
          break
        case 'Prominvest':
          host = 'fill-bill.prominvest.ru'
          break
        case 'Black Sea':
          host = 'blacksea.fill-bill.ru'
          break
        default:
          break
      }
      const reportexcelzip = {
        host: host,
        packageId: row.item.pid
      }
      this.getReportExcelZip(reportexcelzip).then(
        (value) => {
          const fileName = 'Empty_container_registration_table.zip'
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const downloadBlob = new Blob([value.data], { type: value.headers['Content-Type'] })
            window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
          } else {
            try {
              const downloadUrl = window.URL.createObjectURL(new Blob([value.data]), { type: value.headers['Content-Type'] })
              const link = document.createElement('a')
              link.href = downloadUrl
              link.setAttribute('download', fileName)
              document.body.appendChild(link)
              link.click()
              setTimeout(() => {
                link.remove()
                window.URL.revokeObjectURL(downloadUrl)
              }, 2000)
            } catch (error) {
              console.log(error)
            }
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    downloadPDFCommitmentStatement (pages, opt) {
      // this.rowInProgress = row
      const promise = new Promise((resolve, reject) => {
        let worker = html2pdf().set(opt).from(pages[0]).toPdf()
        pages.slice(1).forEach(function (page) {
          worker = worker.get('pdf').then(function (pdf) {
            pdf.addPage()
          }).from(page).toContainer().toCanvas().toPdf()
        })
        worker.save().then(() => {
          resolve()
        })
      })
      promise.then(() => {
        this.$refs.editCommitmentStatement.hide()
        this.reportDatePickerValue1 = this.moment(new Date()).format('YYYY-MM-DD')
        this.reportDatePickerValue2 = this.moment(new Date()).add(6, 'months').format('YYYY-MM-DD')
        this.busyCommitmentStatement = false
        // this.rowInProgress.item.manifest = { id: null, progress: false }
      })
    },
    replaceCommaLine (data) {
      const dataToArray = data.split(',').map(item => item.trim())
      return dataToArray.join('<br>')
    },
    downloadPDFNew (row, pages, opt) {
      this.rowInProgress = row
      const promise = new Promise((resolve, reject) => {
        let worker = html2pdf().set(opt).from(pages[0]).toPdf()
        pages.slice(1).forEach(function (page) {
          worker = worker.get('pdf').then(function (pdf) {
            pdf.addPage()
          }).from(page).toContainer().toCanvas().toPdf()
        })
        worker.save().then(() => {
          resolve()
        })
      })
      promise.then(() => {
        this.rowInProgress.item.manifest = { id: null, progress: false }
      })
    },
    loadPackagesByPagination (page) {
      this.loadPackages(page, { pagination: true }, { search: false })
    },
    loadPackagesBySearchButton (page) {
      this.loadPackages(page, { pagination: false }, { search: true })
    },
    loadPackages (page, obj = { pagination: false }, search = { search: false }) {
      if (search.search === true) {
        this.currentPage = 1
      }

      const params = {
        is_modified: this.modified,
        page: page,
        key: this.searchText,
        prop: this.selected
      }

      if (obj.pagination === true) {
        const myPids = this.pids.slice()
        params.pids = myPids.splice(((page - 1) * 10), 10)
      }

      if (this.datePickerValue !== null) {
        let ISODate = null
        if (this.datePickerValue.end !== null) {
          ISODate = {
            datetime_start: new Date(this.datePickerValue.start.replace(/-/g, '/').replace('T', ' ')).toISOString(),
            datetime_end: new Date(this.datePickerValue.end.replace(/-/g, '/').replace('T', ' ')).toISOString()
          }
        } else {
          const start = this.moment(this.datePickerValue.start).add(3, 'hours').format('YYYY-MM-DD HH:mm')
          const end = this.moment(start).add(1, 'days').subtract(1, 'seconds').format('YYYY-MM-DD HH:mm')
          this.datePickerValue.end = this.moment(this.datePickerValue.start).add(1, 'days').subtract(1, 'seconds').format('YYYY-MM-DD HH:mm')
          ISODate = {
            datetime_start: new Date(start.replace(/-/g, '/').replace('T', ' ')).toISOString(),
            datetime_end: new Date(end.replace(/-/g, '/').replace('T', ' ')).toISOString()
          }
        }
        Object.assign(params, ISODate)
      }
      if (!this.statuses) {
        this.getStatuses({ portalId: this.portalId }).then(
          () => {
            this.getPackagesFromPortal({ portalId: this.portalId, queryParams: params }).then(
              () => {
                this.items = JSON.parse(JSON.stringify(this.packages))
                this.totalRows = this.packages.length
              },
              error => {
                console.log(error)
              }
            )
          },
          (error) => {
            console.log(error)
          }
        )
      } else {
        this.getPackagesFromPortal({ portalId: this.portalId, queryParams: params }).then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.packages))
            this.totalRows = this.packages.length
          },
          error => {
            console.log(error)
          }
        )
      }
    },
    loadDefinitePackage () {
      if (!this.statuses) {
        this.getStatuses({ portalId: this.portalId }).then(
          () => {
            this.getDefinitePackageFromPortal({ portalId: this.portalId, package: 2007568 }).then(
              () => {
                this.items = JSON.parse(JSON.stringify(this.packages))
                this.totalRows = this.packages.length
              },
              error => {
                console.log(error)
              }
            )
          },
          (error) => {
            console.log(error)
          }
        )
      } else {
        this.getDefinitePackageFromPortal({ portalId: this.portalId, package: this.searchPackage }).then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.packages))
            this.totalRows = this.packages.length
          },
          error => {
            console.log(error)
          }
        )
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      // this.currentPage = 1
    },
    openDocuments (row) {
      row.toggleDetails()
      if (row.item.documents === null) {
        this.loadPackageDocuments({ portalId: this.portalId, package: row.item.pid }).then(
          () => {
            row.item.documents = this.documents
            this.processDocuments(row)
          },
          error => {
            console.log(error)
          }
        )
      } else {
        row.item.documents = null
      }
    },
    processDocuments (row) {
      let concatDocTitle = ''
      let concatDocName = ''
      let concatDocForwarder = ''
      let concatDocDecisionNumber = ''
      let concatDocCustom = ''
      let concatDocExecutive = ''
      let concatDocDecision = ''
      let concatDocPreparationDate = ''
      let comissionSignature = null
      let decisionSignature = null
      for (let i = 0; i < row.item.documents.length; i++) {
        const docHtml = row.item.documents[i].html
        try {
          let doc = null
          if (window.DOMParser) {
            const parser = new DOMParser()
            doc = parser.parseFromString(docHtml, 'text/html')
          }
          let title = doc.getElementById('documentTitle')
          if (!title && row.item.documents[i].filename === 'BillofLading.html.cfg.xml') {
            title = 'Коносамент'
          } else if (title) {
            title = title.innerHTML
          } else {
            title = 'Таможенный формат xml'
          }
          if (title.length > 0) {
            row.item.documents[i].documentName = title
          }
          if (row.item.documents[i].filename === 'armti-CommissionShipment.cfg.xml') { // Поручение
            concatDocTitle = title + ' с решением'
            concatDocName = doc.getElementById('NamePersonSignature')
            if (concatDocName) concatDocName = concatDocName.innerHTML
            concatDocForwarder = doc.getElementById('Forwarder')
            if (concatDocForwarder) concatDocForwarder = concatDocForwarder.innerHTML
            concatDocPreparationDate = row.item.documents[i].preparation_date
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              comissionSignature = {
                info: doc.getElementById('signature-info').innerHTML,
                owner: doc.getElementById('signature-owner').innerHTML,
                issued: doc.getElementById('signature-issued').innerHTML,
                valid: doc.getElementById('signature-valid').innerHTML
              }
            }
            doc.getElementsByClassName('signature')[0].remove()
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.general-information { font-size: 9pt; } ' +
              'div.pagebook { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagebook table { font-size: 9pt; } ' +
              'div.pagelandscape { padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagelandscape table { font-size: 8pt; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 9pt; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; } ' +
              'div.title, tr.title td { font-weight: bold; margin-top: 5px; margin-bottom: 5px; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray; white-space: normal; } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray; white-space: normal; } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray; white-space: normal; } ' +
              'tr td.declnumber { word-break: break-all; min-width: 80px; width: 80px; } ' +
              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +
              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].filename === 'CommissionShipmentDecision.html.cfg.xml') { // Решение
            concatDocDecisionNumber = title
            concatDocCustom = doc.getElementById('customs_department')
            if (concatDocCustom) concatDocCustom = concatDocCustom.innerHTML
            concatDocExecutive = doc.getElementById('executive')
            if (concatDocExecutive) concatDocExecutive = concatDocExecutive.innerHTML
            concatDocDecision = doc.getElementById('decision')
            if (concatDocDecision) concatDocDecision = concatDocDecision.innerHTML
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              doc.getElementById('signature-info').setAttribute('style', 'margin-top: 10px')
              doc.getElementById('signature-info').innerHTML = '<b>Решение по поручению подписано усиленной квалифицированной электронной подписью: </b>'
              decisionSignature = {
                info: doc.getElementById('signature-info').innerHTML,
                certificate: doc.getElementById('signature-certificate').innerHTML,
                owner: doc.getElementById('signature-owner').innerHTML,
                issued: doc.getElementById('signature-issued').innerHTML,
                valid: doc.getElementById('signature-valid').innerHTML
              }
            }
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.page { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; padding-bottom: 5mm; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 9pt; } ' +
              '.marg-top { margin-top: 5mm; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; font-size: 9pt; } ' +
              '.graph { font-size: 10pt; } ' +
              '.value { border-bottom: solid 1px black; } ' +
              'div.title, tr.title td { font-weight: bold; } ' +
              '.bordered { border-collapse: collapse; } ' +
              'td.graphMain { vertical-align: top; } ' +
              'td.value.graphMain { vertical-align: bottom; }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray } '
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].filename === 'BillofLading.html.cfg.xml') { // Коносамент
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.page { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; padding-bottom: 5mm; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; } ' +
              'div.title, tr.title td { font-weight: bold; margin-top: 5px; margin-bottom: 5px; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray; white-space: normal; } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray; white-space: normal; } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray; white-space: normal; } ' +
              'tr td.declnumber { word-break: break-all; min-width: 80px; width: 80px; } ' +
              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +
              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].filename === 'GoodsDecision.html.CFG.XML') { // Окончательное решение при перевозке морским транспортом
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              doc.getElementById('signature-info').setAttribute('style', 'margin-top: 10px')
              doc.getElementById('signature-info').innerHTML = '<b>Окончательное решение по судну подписано усиленной квалифицированной электронной подписью: </b>'
            }
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          }
        } catch (e) {
          throw new Error('Ошибка при обработке документа html. ' + (e.message || e))
        }
      }
      this.getMergedDocument(row, row.item.pid, concatDocTitle, concatDocName, concatDocForwarder, concatDocDecisionNumber, concatDocCustom, concatDocExecutive, concatDocDecision, concatDocPreparationDate, comissionSignature, decisionSignature)
    },
    getMergedDocument (row, packageId, title, name, forwarder, decisionNum, custom, executive, decision, date, comissionSignature, decisionSignature) {
      if ((row.item.status === 266) || (row.item.status === 272) || (row.item.status === 273) || (row.item.status === 274) || (row.item.status === 275)) {
        const hasForwarder = forwarder ? '<span>' + forwarder + ', ' + '</span>' : ''
        const hasName = name ? '<span>' + name + '</span>' : ''
        const additionalTable = '<table class="bordered w190"><tbody><tr>' +
          '<td style="width: 50%" class="graphMain bordered">' +
          '<div>Поручение подготовил: ' +
          hasForwarder +
          hasName +
          '</div>' +
          '<div style="white-space: normal; margin-top: 10px;"><b>Поручение подписано электронной подписью:</b></div>' +
          '<div style="white-space: normal;">' + comissionSignature.owner + '</div>' +
          '<div style="white-space: normal;">' + comissionSignature.issued + '</div>' +
          '<div style="white-space: normal;">' + comissionSignature.valid + '</div>' +
          '</td>' +
          '<td style="width: 50%" class="graphMain bordered">' +
          '<div><b>' + decisionNum + '</b></div>' +
          '<div>Таможенный пост: ' + custom + '</div>' +
          '<div>Принятое решение: ' + decision + '</div>' +
          '<div>Дата решения: ' + date + '</div>' +
          '<div>Решение принял: ' + executive + '</div>' +
          '<div style="white-space: normal; margin-top: 10px;"><b>Решение по поручению подписано усиленной квалифицированной электронной подписью:</b></div>' +
          '<div style="white-space: normal;">' + decisionSignature.certificate + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.owner + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.issued + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.valid + '</div>' +
          '</td></tr></tbody></table>'

        let docForView = null
        let docForPdf = null
        const CommissionShipment = row.item.documents.filter((document) => {
          return document.filename.toLowerCase() === ('armti-CommissionShipment.cfg.xml').toLowerCase()
        })
        const mergedDocumentXml = row.item.documents.filter((document) => {
          return document.filename.toLowerCase() === ('COMMISSIONSHIPMENT.cfg.xml').toLowerCase()
        })
        const CommissionShipmentDecision = row.item.documents.filter((document) => {
          return document.filename.toLowerCase() === ('CommissionShipmentDecision.html.cfg.xml').toLowerCase()
        })
        if (window.DOMParser) {
          const parserForView = new DOMParser()
          const parserForPdf = new DOMParser()
          docForView = parserForView.parseFromString(CommissionShipment[0].htmlAfterProcessing, 'text/html')
          docForPdf = parserForPdf.parseFromString(CommissionShipment[0].htmlForPdf, 'text/html')
          const elem1 = document.createElement('div')
          elem1.setAttribute('class', 'pagebook')
          // const elem2 = document.createElement('div')
          // elem2.setAttribute('class', 'pagebook')
          docForView.getElementsByTagName('body')[0].append(elem1)
          docForView.getElementsByClassName('pagebook')[1].innerHTML = additionalTable
          // docForPdf.getElementsByTagName('body')[0].append(elem2)
          // docForPdf.getElementsByClassName('pagebook')[1].innerHTML = additionalTable
          const generalInformation = docForPdf.getElementsByClassName('general-information')[0]
          const pagelandscape = docForPdf.getElementsByClassName('pagelandscape')[0]
          pagelandscape.parentNode.removeChild(pagelandscape)
          row.item.documents[row.item.documents.length] = {
            documentName: title,
            htmlForPdf: docForPdf.getElementsByTagName('html')[0].outerHTML,
            additionalTable: additionalTable,
            generalInformation: generalInformation,
            mergedDocumentXml: mergedDocumentXml[0].xml,
            htmlAfterProcessing: docForView.getElementsByTagName('html')[0].outerHTML,
            package_id: packageId,
            xml: CommissionShipmentDecision[0].xml,
            html: docForView.getElementsByTagName('html')[0].outerHTML
          }
        }
      }
    },
    openDocument (event, document) {
      this.documentFileName = document.filename
      this.documentHtml = document.htmlAfterProcessing
      this.documentXml = document.xml
      this.documentId = document.package_id
      this.documentName = document.documentName.replace('<br>', ' ')
      this.documentHtmlForPdf = document.htmlForPdf
      this.documentAdditionalTable = document.additionalTable
      this.documentGeneralInformation = document.generalInformation
      this.mergedDocumentXml = document.mergedDocumentXml
      event.stopPropagation()
      this.$root.$emit('bv::show::modal', 'openDocument', event)
    },
    addHtmlToIframe () {
      document.getElementById('showDocument').contentWindow.document.open()
      document.getElementById('showDocument').contentWindow.document.write(this.documentHtml)
      document.getElementById('showDocument').contentWindow.document.close()
      document.getElementById('openDocument___BV_modal_content_').setAttribute('style', 'height: ' + (window.innerHeight - 100) + 'px')
    },
    resetProps () {
      this.documentHtml = null
      this.documentName = null
      this.documentXml = null
      this.documentId = null
      this.documentHtmlForPdf = null
    },
    printDocument () {
      document.getElementById('showDocument').contentWindow.print()
    },
    downloadDocumentPdf () {
      let temp = document.createElement('div')
      temp.innerHTML = this.documentHtmlForPdf
      document.getElementById('content').appendChild(temp)
      temp.setAttribute('id', 'download-pdf')
      temp.setAttribute('style', 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; display: none')
      const opt = {
        margin: 0,
        filename: this.documentName + '.pdf',
        image: { type: 'jpeg', quality: 0.96 },
        html2canvas: { scale: 2, width: 794, scrollY: 0, scrollX: 0 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }

      setTimeout(() => {
        import('../../node_modules/html2pdf.js/dist/html2pdf.js').then(html2pdf => {
          html2pdf.default().set(opt).from(document.getElementById('download-pdf').innerHTML).save().then(() => {
            const pdf = document.getElementById('download-pdf')
            pdf.parentNode.removeChild(pdf)
            const style = document.getElementById('content').getElementsByTagName('style')
            for (let i = 0; i < style.length; i++) {
              style[i].parentNode.removeChild(style[i])
            }
            temp = null
          })
        })
      }, 600)
    },
    downloadPDFCommisionShipment (pages, opt) {
      const promise = new Promise((resolve, reject) => {
        let worker = html2pdf().set(opt).from(pages[0]).toPdf()
        pages.slice(1).forEach(function (page) {
          worker = worker.get('pdf').then(function (pdf) {
            pdf.addPage()
          }).from(page).toContainer().toCanvas().toPdf()
        })
        worker.save().then(() => {
          resolve()
        })
      })
      promise.then(() => {
        this.busyCommisionShipment = false
        // window.document.getElementById('myTest').setAttribute('style', 'display: none;')
      })
    },
    downloadDocumentXml () {
      const filename = this.documentId + '.xml'
      const dHref = document.createElement('a')
      const dBlob = new Blob([this.documentXml], { type: 'text/plain' })
      dHref.setAttribute('href', window.URL.createObjectURL(dBlob))
      dHref.setAttribute('download', filename)
      dHref.dataset.downloadurl = ['text/plain', dHref.download, dHref.href].join(':')
      dHref.click()
    },
    getCommitmentStatement (event, row) {
      this.commitmentStatementRow = row
      this.showModal()
    },
    showModal () {
      this.$refs.editCommitmentStatement.show()
    },
    ...mapActions('packages',
      [
        'getPortalsList',
        'getPackagesFromPortal',
        'getDefinitePackageFromPortal',
        'loadPackageDocuments',
        'getStatuses',
        'getReport4',
        'getReport4emptycont_new',
        'getReportExcelZip'
      ]
    )
  }
}
</script>

<style scoped lang="scss">
  .data_table_icon {
    width: 20px;
    height: 20px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  .user-creator-wrapper {
    position: relative;
    i {
      color: #78909C;
      position: absolute;
      top: 0;
      left: 0;
      @extend .data_table_icon;
    }
    .user-creator {
      color: #373A3C;
      font-size: 14px;
      letter-spacing: 0.25px;
      line-height: 20px;
      margin-left: 26px;
    }
  }

  .created-date-wrapper {
    position: relative;
    i {
      color: #78909C;
      position: absolute;
      top: 0;
      left: 0;
      @extend .data_table_icon;
    }
    .created-date {
      color: #373A3C;
      font-size: 14px;
      letter-spacing: 0.25px;
      line-height: 20px;
      margin-left: 26px;
    }
  }

  .destination-wrapper {
    i {
      color: #78909C;
      @extend .data_table_icon;
    }
    .destination {
      color: #373A3C;
      font-size: 14px;
      letter-spacing: 0.25px;
      line-height: 20px;
    }
  }

  #select-server {
    font-size: 14px;
    height: 40px;
  }

  #filter-by-category {
    font-size: 14px;
    height: 40px;
  }

  .search {
    position: relative;
  }

  .container_search_close {
    position: absolute;
    right: 20px;
    top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  .attachments-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    .attachment {
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 15px 10px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
      position: relative;
      min-height: 80px;
      &:hover {
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
        cursor: pointer;
      }
      .attachment-inner-container {
        display: flex;
        width: 100%;
        /* word-break: break-all; */
        .file-icon-wrapper {
          margin-right: 10px;
          i {
            font-size: 32px;
            color: #78909C;
            /* min-height: 80px; */
          }
        }
        .attachment-name-wrapper {
          font-size: 14px;
          letter-spacing: 0.25px;
          line-height: 20px;
          color: #37474F;
        }
      }
    }
  }

  .no-documents {
    width: 100%;
    text-align: center;
  }
</style>
